import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.less";
import { AdidasLogoStandard, AdidasLogoOriginals } from "./images";

class Logo extends Component {
  renderImage() {
    const { title } = this.props;
    const isSpezial = "Special";
    const isOriginals = "Originals";

    const logo =
      title.indexOf(isSpezial) !== -1 || title.indexOf(isOriginals) !== -1
        ? AdidasLogoOriginals
        : AdidasLogoStandard;

    return <img src={logo} alt="logo" />;
  }
  render() {
    const { brand } = this.props;
    return brand === "adidas" ? (
      <div id="brandLogo">{this.renderImage()}</div>
    ) : null;
  }
}

const mapStateToProps = ({ app }) => {
  return {
    title: app.data.title,
    brand: app.data.brand
  };
};

export default connect(mapStateToProps)(Logo);
